import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { HttpCode } from 'types';
import { HTTP_CODE } from 'common/constants';
import { getStoreErrorCode } from 'features/store/ducks/get-store-by-id';
import { getModelErrorCode } from 'features/page-model/ducks/get-model';
import { getStoresListErrorCode } from 'features/stores/ducks/get-stores';

export function useErrorCode() {
  const model = useSelector(getModelErrorCode);
  const store = useSelector(getStoreErrorCode);
  const storeList = useSelector(getStoresListErrorCode);

  const [code, setCode] = useState<HttpCode | null>(null);

  const error = useMemo(() => [store, model, storeList].find(Boolean), [store, model, storeList]);

  useEffect(() => {
    if (error) {
      if (error === HTTP_CODE.NOT_FOUND) {
        setCode(error);
      } else {
        setCode(HTTP_CODE.SERVER_ERROR);
      }
    }
  }, [error]);

  return code;
}
